import { render, staticRenderFns } from "./IconText.vue?vue&type=template&id=2f18c180&"
import script from "./IconText.vue?vue&type=script&lang=js&"
export * from "./IconText.vue?vue&type=script&lang=js&"
import style0 from "./IconText.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports